import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';

/** Data passed from macro or other callers. All fields optional. */
export interface GenericContentDialogData {
  /** Dialog title (falls back to message if not set) */
  title?: string;
  /** Body text or title when title is not provided */
  message?: string;
  /** Image URL – shown with loader until loaded */
  imageUrl?: string;
  /** If set, OK button navigates to this route */
  route?: string;
  /** Optional HTML content (sanitized). Use for rich content from macros */
  htmlContent?: string;
}

@Component({
    selector: 'app-generic-content-dialog',
    templateUrl: './generic-content-dialog.component.html',
    styleUrls: ['./generic-content-dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatProgressSpinner, MatDialogActions, MatButton, MatDialogClose, RouterLink]
})
export class GenericContentDialogComponent implements OnInit {
  imageLoading = true;
  safeHtml: SafeHtml | null = null;
  /** Blob / data URLs must bypass sanitizer or Angular prefixes them with unsafe: */
  safeImageUrl: SafeUrl | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: GenericContentDialogData & { [key: string]: any },
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    if (this.data?.imageUrl) {
      this.safeImageUrl = this.sanitizer.bypassSecurityTrustUrl(this.data.imageUrl);
    } else {
      this.imageLoading = false;
    }
    if (this.data?.htmlContent) {
      this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.data.htmlContent);
    }
  }

  get title(): string {
    return this.data?.title ?? this.data?.message ?? '';
  }

  get showMessageAsBody(): boolean {
    return !!(this.data?.title && this.data?.message);
  }

  onImageLoad(): void {
    this.imageLoading = false;
  }

  onImageError(): void {
    this.imageLoading = false;
  }
}
